import {
  targetGroupsBySNConstants,
  createTargetGroupsBySNConstants,
  editTargetGroupsBySNConstants,
  addTargetGroupsBySNConstants,
  removeTargetGroupsBySNConstants,
  deleteTargetGroupsBySNConstants,
} from "../_redux-constants";

export function targetGroupsSNReducer(
  state = {
    targetGroupsBySNLoading: false,
    targetGroupsBySNData: null,
    targetGroupsBySNError: null,

    createTargetGroupsBySNLoading: false,
    createTargetGroupsBySNData: null,
    createTargetGroupsBySNError: null,

    editTargetGroupsBySNLoading: false,
    editTargetGroupsBySNData: null,
    editTargetGroupsBySNError: null,

    addTargetGroupsBySNLoading: false,
    addTargetGroupsBySNData: null,
    addTargetGroupsBySNError: null,

    removeTargetGroupsBySNLoading: false,
    removeTargetGroupsBySNData: null,
    removeTargetGroupsBySNError: null,

    deleteTargetGroupsBySNLoading: false,
    deleteTargetGroupsBySNData: null,
    deleteTargetGroupsBySNError: null,
  },
  action
) {
  switch (action.type) {
    case targetGroupsBySNConstants.TARGET_GROUPS_BY_SN_LOADING:
      return Object.assign({}, state, {
        targetGroupsBySNLoading: true,
        targetGroupsBySNData: null,
        targetGroupsBySNError: null,
      });
    case targetGroupsBySNConstants.TARGET_GROUPS_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsBySNLoading: false,
        targetGroupsBySNData: action.data,
      });
    case targetGroupsBySNConstants.TARGET_GROUPS_BY_SN_FAILURE:
      return Object.assign({}, state, {
        targetGroupsBySNLoading: false,
        targetGroupsBySNData: null,
        targetGroupsBySNError: action.error,
      });
    case createTargetGroupsBySNConstants.CREATE_TARGET_GROUPS_BY_SN_LOADING:
      return Object.assign({}, state, {
        createTargetGroupsBySNLoading: true,
        createTargetGroupsBySNData: null,
        createTargetGroupsBySNError: null,
      });
    case createTargetGroupsBySNConstants.CREATE_TARGET_GROUPS_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        createTargetGroupsBySNLoading: false,
        createTargetGroupsBySNData: action.data,
      });
    case createTargetGroupsBySNConstants.CREATE_TARGET_GROUPS_BY_SN_FAILURE:
      return Object.assign({}, state, {
        createTargetGroupsBySNLoading: false,
        createTargetGroupsBySNData: null,
        createTargetGroupsBySNError: action.error,
      });
    case editTargetGroupsBySNConstants.EDIT_TARGET_GROUPS_BY_SN_LOADING:
      return Object.assign({}, state, {
        editTargetGroupsBySNLoading: true,
        editTargetGroupsBySNData: null,
        editTargetGroupsBySNError: null,
      });
    case editTargetGroupsBySNConstants.EDIT_TARGET_GROUPS_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        editTargetGroupsBySNLoading: false,
        editTargetGroupsBySNData: action.data,
      });
    case editTargetGroupsBySNConstants.EDIT_TARGET_GROUPS_BY_SN_FAILURE:
      return Object.assign({}, state, {
        editTargetGroupsBySNLoading: false,
        editTargetGroupsBySNData: null,
        editTargetGroupsBySNError: action.error,
      });
    case addTargetGroupsBySNConstants.ADD_TARGET_GROUPS_BY_SN_LOADING:
      return Object.assign({}, state, {
        addTargetGroupsBySNLoading: true,
        addTargetGroupsBySNData: null,
        addTargetGroupsBySNError: null,
      });
    case addTargetGroupsBySNConstants.ADD_TARGET_GROUPS_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        addTargetGroupsBySNLoading: false,
        addTargetGroupsBySNData: action.data,
      });
    case addTargetGroupsBySNConstants.ADD_TARGET_GROUPS_BY_SN_FAILURE:
      return Object.assign({}, state, {
        addTargetGroupsBySNLoading: false,
        addTargetGroupsBySNData: null,
        addTargetGroupsBySNError: action.error,
      });
    case removeTargetGroupsBySNConstants.REMOVE_TARGET_GROUPS_BY_SN_LOADING:
      return Object.assign({}, state, {
        removeTargetGroupsBySNLoading: true,
        removeTargetGroupsBySNData: null,
        removeTargetGroupsBySNError: null,
      });
    case removeTargetGroupsBySNConstants.REMOVE_TARGET_GROUPS_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        removeTargetGroupsBySNLoading: false,
        removeTargetGroupsBySNData: action.data,
      });
    case removeTargetGroupsBySNConstants.REMOVE_TARGET_GROUPS_BY_SN_FAILURE:
      return Object.assign({}, state, {
        removeTargetGroupsBySNLoading: false,
        removeTargetGroupsBySNData: null,
        removeTargetGroupsBySNError: action.error,
      });

    case deleteTargetGroupsBySNConstants.DELETE_TARGET_GROUPS_BY_SN_LOADING:
      return Object.assign({}, state, {
        deleteTargetGroupsBySNLoading: true,
        deleteTargetGroupsBySNData: null,
        deleteTargetGroupsBySNError: null,
      });
    case deleteTargetGroupsBySNConstants.DELETE_TARGET_GROUPS_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        deleteTargetGroupsBySNLoading: false,
        deleteTargetGroupsBySNData: action.data,
      });
    case deleteTargetGroupsBySNConstants.DELETE_TARGET_GROUPS_BY_SN_FAILURE:
      return Object.assign({}, state, {
        deleteTargetGroupsBySNLoading: false,
        deleteTargetGroupsBySNData: null,
        deleteTargetGroupsBySNError: action.error,
      });
    default:
      return state;
  }
}
